import createAPI from '../axios'

// 人才培养方案相关API
const teachingManage = {
    teachingScheme: {
		initOption: config => createAPI('/teachingManage/teachingScheme/initOption', 'post', config),
        list: config => createAPI('/teachingManage/teachingScheme/list', 'post', config),
        deleteById: config => createAPI('/teachingManage/teachingScheme/deleteById', 'post', config),
        saveScheme: config =>createAPI('teachingManage/teachingScheme/saveScheme','post',config),
        queryCourses:config => createAPI('teachingManage/teachingScheme/queryCourses','post',config),
        queryAllCourses:config => createAPI('teachingManage/teachingScheme/queryAllCourses','post',config),
        queryAllPositions:config => createAPI('teachingManage/teachingScheme/queryAllPositions','post',config),
        loadMajors:config => createAPI('teachingManage/teachingScheme/queryMajors','post',config),
        loadDomain:config => createAPI('teachingManage/teachingScheme/loadDomain','post',config),
        loadPosition:config => createAPI('teachingManage/teachingScheme/loadPosition','post',config),
        loadCertificate:config => createAPI('teachingManage/teachingScheme/loadCertificate','post',config),
        loadMode:config => createAPI('teachingManage/teachingScheme/loadMode','post',config),
        loadTerms:config => createAPI('teachingManage/teachingScheme/loadTerms','post',config),
        loadComboOption:config => createAPI('teachingManage/teachingScheme/loadComboOption','post',config),
        loadInfo:config => createAPI('teachingManage/teachingScheme/loadInfo','post',config),
        isRepeat:config => createAPI('teachingManage/teachingScheme/isRepeat','post',config),
        uploadScheme:config => createAPI('teachingManage/teachingScheme/upload','post',config),
        deleteFile:config => createAPI('teachingManage/teachingScheme/deleteFile','post',config),
        sduplicate:config => createAPI('teachingManage/teachingScheme/sduplicate','post',config),
        mduplicate:config => createAPI('teachingManage/teachingScheme/mduplicate','post',config),
        queryMajorsInScheme:config => createAPI('teachingManage/teachingScheme/queryMajorsInScheme','post',config),
        singleExport:config => createAPI('teachingManage/teachingScheme/singleExport','post',config),
        syncData:config => createAPI('teachingManage/teachingScheme/syncData','post',config),
        updateAuditState:config => createAPI('teachingManage/teachingScheme/updateAuditState','post',config),
        export: config => createAPI('teachingManage/teachingScheme/export', 'post', config),
        createTeachingScheme: config => createAPI('/teachingManage/teachingScheme/createTeachingScheme', 'post', config),
        importCourse: config => createAPI('/teachingManage/teachingScheme/importCourse', 'post', config),
        importTeachingProgress: config => createAPI('/teachingManage/teachingScheme/importTeachingProgress', 'post', config),
        exportTeachingProgress: config => createAPI('/teachingManage/teachingScheme/exportTeachingProgress', 'post', config),
        queryGGKAuth: config => createAPI('/teachingManage/teachingScheme/queryGGKAuth', 'post', config),
        showPieChart: config => createAPI('/teachingManage/teachingScheme/showPieChart', 'post', config),
        queryProgressTypeStatistics: config => createAPI('/teachingManage/teachingScheme/queryProgressTypeStatistics', 'post', config),
        saveSubtotal: config => createAPI('/teachingManage/teachingScheme/saveSubtotal', 'post', config),
        checkKcxsxjExit: config => createAPI('/teachingManage/teachingScheme/checkKcxsxjExit', 'post', config),
        classOption: config => createAPI('/teachingManage/teachingScheme/classOption', 'post', config),

        queryJxjcbgList: config => createAPI('/teachingManage/teachingScheme/queryJxjcbgList', 'post', config),
        loadCourseCombo: config => createAPI('/teachingManage/teachingScheme/loadCourseCombo', 'post', config),
        saveJxjcbg: config => createAPI('/teachingManage/teachingScheme/saveJxjcbg', 'post', config),
        deleteJxjcbgById: config => createAPI('/teachingManage/teachingScheme/deleteJxjcbgById', 'post', config),
        updateAuditState_jxjc: config => createAPI('/teachingManage/teachingScheme/updateAuditState_jxjc', 'post', config),
        queryOldJxjcInfo: config => createAPI('/teachingManage/teachingScheme/queryOldJxjcInfo', 'post', config),

        inheritCourseConfirm: config => createAPI('/teachingManage/teachingScheme/inheritCourseConfirm', 'post', config),
        
        queryAuditFlow: config => createAPI('/teachingManage/teachingScheme/queryAuditFlow', 'post', config),
    },
    coursePreConfig: {
        initCombo: config => createAPI('/teachingManage/coursePreConfig/initCombo', 'post', config),
        queCourseList: config => createAPI('/teachingManage/coursePreConfig/queCourseList', 'post', config),
        saveCourseRec: config => createAPI('/teachingManage/coursePreConfig/saveCourseRec', 'post', config),
        delCourseRec: config => createAPI('/teachingManage/coursePreConfig/delCourseRec', 'post', config),
        queMajorList: config => createAPI('/teachingManage/coursePreConfig/queMajorList', 'post', config),
        queMajorTree: config => createAPI('/teachingManage/coursePreConfig/queMajorTree', 'post', config),
        saveMajorRec: config => createAPI('/teachingManage/coursePreConfig/saveMajorRec', 'post', config),
        delMajorRec: config => createAPI('/teachingManage/coursePreConfig/delMajorRec', 'post', config),
        courseOption: config => createAPI('/teachingManage/coursePreConfig/courseOption', 'post', config),
        inheritCourseConfirm: config => createAPI('/teachingManage/coursePreConfig/inheritCourseConfirm', 'post', config),
    },
    relatedCourse: {
        list: config => createAPI('/teachingManage/relatedCourse/list', 'post', config),
        initCombo: config => createAPI('/teachingManage/relatedCourse/initCombo', 'post', config),
        majorCombo: config => createAPI('/teachingManage/relatedCourse/majorCombo', 'post', config),
        courseCombo: config => createAPI('/teachingManage/relatedCourse/courseCombo', 'post', config),
        save: config => createAPI('/teachingManage/relatedCourse/save', 'post', config),
        del: config => createAPI('/teachingManage/relatedCourse/del', 'post', config),
    },
    domain: {
        list: config => createAPI('/teachingManage/domain/list', 'post', config),
        save: config => createAPI('/teachingManage/domain/save', 'post', config),
        deleteById: config => createAPI('/teachingManage/domain/deleteById', 'post', config),
        syncData:config => createAPI('teachingManage/domain/syncData','post',config),
    },
    certification: {
        list: config => createAPI('/teachingManage/certification/list', 'post', config),
        save: config => createAPI('/teachingManage/certification/save', 'post', config),
        deleteById: config => createAPI('/teachingManage/certification/deleteById', 'post', config),
    },
    position: {
        list: config => createAPI('/teachingManage/position/list', 'post', config),
        save: config => createAPI('/teachingManage/position/save', 'post', config),
        deleteById: config => createAPI('/teachingManage/position/deleteById', 'post', config),
        initParams: config => createAPI('/teachingManage/position/initParams', 'post', config),
    },
    teachingTaskBook: {
        queryList: config => createAPI('/teachingManage/teachingTaskBook/queryList', 'post', config),
        initCombo: config => createAPI('/teachingManage/teachingTaskBook/initCombo', 'post', config),
        loadTea: config => createAPI('/teachingManage/teachingTaskBook/loadTea', 'post', config),
        exportFile: config => createAPI('/teachingManage/teachingTaskBook/exportFile', 'post', config),
        test: config => createAPI('/handleData/teachingTask', 'post', config),
    },
};

export default teachingManage



// WEBPACK FOOTER //
// ./src/api/modules/teachingManage.js